module.exports = __webpack_public_path__ + "img/card_programa_servicios_estudiantes.377e895b.svg";